import { useContext } from 'react'
import { ConsentContext } from './consent-provider.js'
import type { ConsentContextValue } from './consent-provider.js'

/**
 * Hook to access consent state and helpers from within a ConsentProvider.
 *
 * @example
 * ```tsx
 * const { consent, hasCategory, showBanner } = useConsent()
 * if (hasCategory('analytics')) {
 *   // load analytics scripts
 * }
 * ```
 */
export function useConsent(): ConsentContextValue {
  const ctx = useContext(ConsentContext)
  if (!ctx) {
    throw new Error('useConsent must be used within a <ConsentProvider>')
  }
  return ctx
}
